import React, { useContext } from "react";
import Author from "./Author";
import "./style/BestAuthersList.css";
import { UserContext } from "./context/Context";

function BestAuthersList() {
  const [user, setUser] = useContext(UserContext);
  return (
    <div className="bestAuthersList">
      <h2>Best authors</h2>
      <Author
        src="https://images.unsplash.com/photo-1509967419530-da38b4704bc6?ixid=MXwxMjA3fDB8MHxzZWFyY2h8NXx8ZmFjZXxlbnwwfHwwfA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
        name="Marla Fox"
      />
      <Author
        src="https://images.unsplash.com/photo-1509460913899-515f1df34fea?ixid=MXwxMjA3fDB8MHxzZWFyY2h8MTJ8fGZhY2V8ZW58MHx8MHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
        name="Kevin brandol"
      />
      <Author
        src="https://images.unsplash.com/photo-1544348817-5f2cf14b88c8?ixid=MXwxMjA3fDB8MHxzZWFyY2h8Mjd8fGZhY2V8ZW58MHx8MHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
        name="Jhonathan Bird"
      />
      <Author
        src="https://images.unsplash.com/photo-1550639524-a6f58345a2ca?ixid=MXwxMjA3fDB8MHxzZWFyY2h8MjF8fGZhY2V8ZW58MHx8MHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
        name="Niki Marston"
      />
      <Author
        src="https://images.unsplash.com/photo-1604426633861-11b2faead63c?ixid=MXwxMjA3fDB8MHxzZWFyY2h8OXx8ZmFjZXxlbnwwfHwwfA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
        name="Katrin Mistry"
      />
    </div>
  );
}

export default BestAuthersList;
